class NPSApi {
  constructor(client, url) {
    this.url = url
    this.client = client
  }
  sendNps(api_key, params) {
    return this.client.post(`api/companies/${api_key}/nps`, params).then((response) => response.data)
  }
}

export default NPSApi
